module.exports = __webpack_public_path__ + "static/media/VectorPointCancel.140bb08f.svg";